import { useCallback, useMemo } from 'react'
import { Dialog, DialogContent, DialogTitle, makeStyles, IconButton, Icon } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import { FONT_WEIGHTS } from '../../../../utils'
import { purple, gray } from '../../../../utils/colors'
import useDaycareVisit from '../../../../hooks/useDaycareVisit'

const useStyles = makeStyles(() => ({
	content: { display: 'flex', flexDirection: 'column', gap: '.6rem' },
	header: {
		display: 'flex',
		marginBottom: '.8rem',
		justifyContent: 'flex-end',
		gap: '.5rem',
		'& div:nth-child(2)': {
			flex: 1,
			display: 'flex',
			alignItems: 'center'
		},
		'& .MuiIconButton-root .MuiIconButton-label .MuiSvgIcon-root': {
			fill: gray[800]
		}
	},
	infoIconContainer: {
		display: 'flex',
		alignItems: 'center'
	},
	infoIcon: {
		color: purple[500],
		fontSize: '1.18rem',
		fontWeight: FONT_WEIGHTS.ExtraBold,
		overflow: 'unset'
	},
	titleText: {
		fontWeight: FONT_WEIGHTS.ExtraBold,
		fontSize: '1rem',
		textTransform: 'uppercase'
	},
	headerText: {
		fontWeight: FONT_WEIGHTS.ExtraBold,
		fontSize: '1rem'
	},
	policyText: {
		fontFamily: 'Nunito',
		fontSize: '1rem'
	}
}))

const CancellationPolicyDialog = ({ open, onClose, numPets }) => {
	const classes = useStyles()

	const { getCancellationPolicy } = useDaycareVisit()

	const text = useMemo(() => {
		return getCancellationPolicy(numPets)
	}, [getCancellationPolicy, numPets])

	const handleOnClose = useCallback(() => {
		if (onClose) {
			onClose()
		}
	}, [onClose])

	return (
		<Dialog
			PaperProps={{
				style: {
					width: 400,
					maxWidth: 400,
					maxHeight: 400,
					minWidth: 400
				}
			}}
			maxWidth="md"
			open={open}
			onClose={handleOnClose}>
			<DialogTitle>
				<div className={classes.header}>
					<div className={classes.infoIconContainer}>
						<Icon className={`fas fa-info-circle ${classes.infoIcon}`} />
					</div>
					<div className={classes.titleText}>Cancellation Policy</div>
					<IconButton disableRipple style={{ padding: 0, flex: 0 }}>
						<Close onClick={handleOnClose} />
					</IconButton>
				</div>
			</DialogTitle>
			<DialogContent className={classes.content}>
				<div>{text}</div>
			</DialogContent>
		</Dialog>
	)
}

export default CancellationPolicyDialog
